import { useCallback } from "react";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { GenerateUrlRequestBody, Paginated, PaginationQuery } from "../../types";
import { buildUrl, mutateCache, useApi } from "../api";
import { CustomError } from "../errors";
import { AdminText, UpdateTextNewImageBody, UpdateTextRemoveImageBody } from "./types/texts";

export const useTextsApi = () => {
  const api = useApi();

  const getAdminText = useCallback(
    (signal: AbortSignal) => {
      const url = `/admin/settings/patrol/texts`;
      return useSWRMutation<AdminText, CustomError, string, string>(url, (url, { arg }: { arg: string }) =>
        api.get<AdminText>({ url: `${url}/${arg}`, signal }),
      );
    },
    [api],
  );

  const useAdminTexts = useCallback(
    (query: PaginationQuery, signal: AbortSignal) => {
      const url = buildUrl("/admin/settings/patrol/texts", query);
      return useSWR<Paginated<AdminText>, CustomError, string>(url, (url) =>
        api.get<Paginated<AdminText>>({ url, signal }),
      );
    },
    [api],
  );

  // const insertAdminText = useCallback(
  //   async (body: InsertTextBody): Promise<{ id: string }> => {
  //     const url = `/admin/settings/patrol/texts`;
  //     const text = await api.post<{ id: string }, InsertTextBody>(url, body);
  //     mutateCache([url]);
  //     return text;
  //   },
  //   [api]
  // );

  const updateAdminText = useCallback(
    async (textId: string, body: UpdateTextRemoveImageBody | UpdateTextNewImageBody): Promise<void> => {
      const url = `/admin/settings/patrol/texts/${textId}`;
      (await api.put<UpdateTextRemoveImageBody | UpdateTextNewImageBody>(url, body),
        mutateCache(["/admin/settings/patrol/texts"]));
    },
    [api],
  );

  // const deleteAdminText = useCallback(
  //   async (textId: string): Promise<void> => {
  //     const url = `/admin/settings/patrol/texts/${textId}`;
  //     await api.del(url)
  //       mutateCache([`/admin/settings/patrol/texts`]);
  //   },
  //   [api]
  // );

  const generateUploadImageUrl = useCallback(
    async (textId: string, fileName: string, fileType: string): Promise<string> => {
      const encodedFileName = encodeURIComponent(fileName);
      const url = `/admin/settings/patrol/texts/${textId}/image/generate_upload_url?file_name=${encodedFileName}`;
      return api.post<string, GenerateUrlRequestBody>(url, {
        filename: fileName,
        contentType: fileType,
      });
    },
    [api],
  );

  return {
    getAdminText,
    useAdminTexts,
    // insertAdminText,
    updateAdminText,
    // deleteAdminText,
    generateUploadImageUrl,
  };
};
